import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, setDoc, doc, addDoc, collection } from "firebase/firestore";
import { auth, db, } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { Password } from '@mui/icons-material';
import { getFunctions, httpsCallable } from "firebase/functions";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
// import { functions } from '../../../firebase';


const roles = [

  { label: 'Admin', value: 'adminAccess' },

  { label: 'Sub Admin', value: 'subadminAccess' },

  { label: 'Agency', value: 'agencyAccess' },

];

const date = new Date().toDateString()



const New = ({inputs, title}) => {

  const [file, setFile ] = useState("")
  const [firstname, setFirstname] = useState("")
  const [lastname, setLastname] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [confirmpassword, setConfirmpassword] = useState("")
  const [telephone, setTelephone] = useState("")
  const [role, setRole] = useState("")
  const [status, setStatus] = useState("inactive")
  const [data, setData ] = useState({})
  const [perc, setPerc ] = useState(null)
  const [message, setMessage] = useState('')
  const [firstnameerror, setFirstnameerror] = useState("")
  const [lastnameerror, setLastnameerror] = useState("")
  const [emailerror, setEmailerror] = useState("")
  const [passworderror, setPassworderror] = useState("")
  const [confirmpassworderror, setConfirmpassworderror] = useState("")
  const [roleerror, setRoleerror] = useState("")
  const [telephoneerror, setTelephoneerror] = useState("")
  const [error, setError] = useState(false)

  
  const [isloading, setIsloading] = useState(false)

  const [adminId, setAdminId] = useState("")

  
  const navigate = useNavigate();


  const handleRoleChange = (e) => {

    setRole(e.target.value);
 
  };

  const Spinner = () => {
  return(
    <span className='spinner-container'>
        <span className='loading-spinner'></span>
    </span>
  )
  }

  
  const handleAdd = async(e) => {

    e.preventDefault()

    if(email === "") {
      return setEmailerror('Email is required')
      
    }

     if(password === "") {
      return setPassworderror('Password is required')
      
    }

    if(confirmpassword === "") {
      return setConfirmpassworderror('Confirm Password is required')
      
    }

    if(password !== confirmpassword){
      return setConfirmpassworderror('Password and confirm Password must be the same')
      
    }

    if(firstname === "") {
      return setFirstnameerror('firstname is required')
      
    }

    if(lastname === "") {
      return setLastnameerror('lastname is required')
    
    }

     if(telephone === "") {
      return setTelephoneerror('lastname is required')
    
    }

    if(role === "") {
      return setRoleerror('role is required')
      
    }

    setIsloading(true)


    try{

      const res = await createUserWithEmailAndPassword(auth, email, password);

      // console.log('res: ', res)

      if (res) {

        const functions = getFunctions();
        const callableFunction = httpsCallable(functions, 'addAdmin');
        const result = await callableFunction({ email: email });

        

        // Get the response from the function
        // setMessage(result.data.message);  // Update UI with the message

        console.log(result.data.message)

        setAdminId(res.uid)

        

         await setDoc(doc(db, "admins", res.user.uid), {
           email : email,
          //  password : password,
           firstname : firstname,
           lastname : lastname,
           telephone : telephone,
           role : role,
           status : status,
           date : date,
           adminId : adminId,
           timeStamp: serverTimestamp(),
     
        })

        setIsloading(false)

        navigate('/settings')

        alert(result.data.message)


        
      }

      
    }catch (err) {
      console.log('error ', err);

      alert('Email already exists')

      return setError(true)

      
    } 

  }

  // console.log(role)

  return (
    <div className="new">
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Chillaxia Admin</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/settings"
            >
              Admin List
            </Link>
            <Typography color="green">New Admin</Typography>
          </Breadcrumbs>
          </div>
        </div>
         <div>
              <span>{message}</span>
            </div>
        <div className='top'>
         
           
            <div className="left">

              
               <span style={{color:'red', fontSize:14}}>{error && 'Email already exist'}</span>

            <div className='form'  >
            {/* <div className='formInput' > */}


               
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                  <TextField
                    id="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value = {email}
                    placeholder="Enter Email"
                    type="email"
                    style={{width:'100%'}}
                  />

                  {emailerror &&
                  <p style={{color:'red', fontSize:10, marginVertical:5}}> {emailerror}</p>
                  }
            

                  </div>

               
                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>

                <TextField
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value = {password}
                  placeholder="Enter Password"
                  style={{width:'100%'}}
                  type="password"
                />

                {passworderror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {passworderror}</p>
                }

                </div>

                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                  <TextField
                  id="confirmpassword"
                  onChange={(e) => setConfirmpassword(e.target.value)}
                  value = {confirmpassword}
                  placeholder="Re-enter Password"
                  style={{width:'100%'}}
                  type="password"
                />

                {confirmpassworderror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {confirmpassworderror}</p>
                }

                </div>
             
                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>

                <TextField
                  id="firstname"
                  onChange={(e) => setFirstname(e.target.value)}
                  value = {firstname}
                  placeholder="Enter Firstname"
                  style={{width:'100%'}}
                />

                {firstnameerror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {firstnameerror}</p>
                }

                </div>
       
               <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                <TextField
                  id="lastname"
                  onChange={(e) => setLastname(e.target.value)}
                  value = {lastname}
                  placeholder="Enter Lastname"
                  style={{width:'100%'}}
                />

                {lastnameerror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {lastnameerror}</p>
                }

               </div>
             
              
              <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>

                  <TextField
                  id="telephone"
                  onChange={(e) => setTelephone(e.target.value)}
                  value = {telephone}
                  placeholder="+2348139444402"
                  style={{width:'100%'}}
                />

                  {telephoneerror &&
                  <p style={{color:'red', fontSize:10, marginVertical:5}}> {telephoneerror}</p>
                  }


              </div>

         
              <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

              <Box sx={{ minWidth: '100%' }}>
              <FormControl fullWidth>
              <InputLabel id="role" style={{color:'#999', fontWeight:300}}>Select Your Outlet Role</InputLabel>
              <Select
                labelId="role"
                id="role"
                value={role}
                label="role"
                onChange={(e) => setRole(e.target.value)}
          
              >

          

            {roles.map((item) => { 

                return(

                  <MenuItem key={item.key} value={item.value}>
                  
                      {item.label}
                 
                  </MenuItem>

                ) 
              })} 

            </Select>
            </FormControl>
            </Box>

               <span style={{color:'red', fontSize:10}}>{roleerror && roleerror}</span>
              </div>

          

                <Button 
                onClick={handleAdd}
                // disabled={perc !== null && perc < 100}
                style={{width:'100%', height: 60, backgroundColor:'rgb(15, 31, 175)', paddingTop:10, paddingBottom:10, color:'white'}}>{isloading ? "...Loading": 'Add Admin'}
                </Button>
            </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default New
